var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import Box from "../box/Box";
export default (function (_a) {
    var item1 = _a.item1, item2 = _a.item2, item3 = _a.item3, rest = __rest(_a, ["item1", "item2", "item3"]);
    return (React.createElement(Box, __assign({}, rest, { maxWidth: "${theme('gridMaxWidth')}px", mx: "auto", display: "grid", gridTemplateColumns: ["1fr 1fr", "repeat(12, 1fr)"], gridTemplateRows: [
            "min-content min-content",
            "min-content 1fr 1fr 1fr 1fr 1fr 1fr"
        ], px: [1, 3] }),
        React.createElement(Box, { p: 2, display: ["flex", "block"], alignItems: "flex-end", gridColumn: ["2 / 3", "5 / span 2"], gridRow: ["1 / 1", "1 / span 1"] }, item1),
        React.createElement(Box, { p: 2, display: ["flex", "block"], alignItems: "flex-end", gridColumn: ["1 / 2", "2 / span 2"], gridRow: ["1 / 1", "3 / span 2"] }, item2),
        React.createElement(Box, { p: 2, gridColumn: ["1 / -1", "7 / span 5"], gridRow: ["2 / 3", "4 / span 4"] }, item3)));
});
//# sourceMappingURL=MediaCollage02.js.map